export class League {
    id: number;
    leagueId: number;
    country: string;
    description: string;
    name: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/league.model.ts